import type { ExtendedRouteObject } from '#/routes/types';
import loader, { id, type LoaderData, type Params } from './loader';

export default {
  id,
  path: '/underskriv/:documentId',
  loader,
  lazy: {
    Component: async () => (await import('./index')).default,
  },
  handle: () => ({
    hideSideNavigation: true,
  }),
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
